import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
/* eslint-disable no-undef */
import Vue from 'vue';
import Vuex from 'vuex';
import VueCookie from 'vue-cookies';
import jslinq from 'jslinq';
Vue.use(Vuex);
Vue.use(VueCookie);
class AppState {
  constructor() {
    this.profileOpen = false;
    this.currentTab = 'tab-cart'; //tabella aperta del profilo ;
    this.coloreMetalloAste = 'GUN';
    this.coloreAste = "";
    this.lenteSx = null;
    this.lenteDx = null;
    this.tintaUnita = false;
    this.filteredTemples = [];
    this.marchio = 'DEMENEGO';
    this.btActive = false;
    this.itemsLoaded = false;
    this.sessionId = null;
  }
}
export default new Vuex.Store({
  state: new AppState(),
  mutations: {
    setMarchio(state, marchio) {
      state.marchio = marchio;
    },
    setBtActive(state, btActive) {
      state.btActive = btActive;
    },
    setTintaUnita(state, n) {
      state.tintaUnita = n;
    },
    setItemsLoaded(state, itemsLoaded) {
      state.itemsLoaded = itemsLoaded;
    },
    setFilteredTemples(state, filteredTemples) {
      state.filteredTemples = filteredTemples;
    },
    setSessionId(state, sessionId) {
      state.sessionId = sessionId;
    },
    setTemplesMetalColor(state, metalColor) {
      state.coloreMetalloAste = metalColor;
    },
    /**
     * Questa funzionae ripristina una configurazione passata come parametro
     * @param {object} state store
     * @param {object} configuration configurazione da ripristinare
     */
    restoreConfigurationObject(state, configuration) {
      state.configurator.frontale = configuration.frontale; //modello frontale
      state.configurator.calibro = configuration.calibro;
      state.configurator.naso = configuration.naso;
      state.configurator.asianFitting = configuration.asianFitting;
      state.configurator.colore = configuration.colore;
      state.configurator.finitura = configuration.finitura;
      state.configurator.coloreAste = configuration.coloreAste;
      state.configurator.coloreMetalloAste = configuration.ColoreMetalloAste;
      state.configurator.misuraAste = configuration.misuraAste;
      state.configurator.frontali.name = configuration.nome;
      state.configurator.frontali.nameColor = configuration.coloreNome;
      state.configurator.note = configuration.note;
    },
    resetLentiVista(state) {
      state.configurator.lenteVistaDx = null;
      state.configurator.lenteVistaSx = null;
      // state.configurator.lenti!.sferaDx = 0;
      // state.configurator.lenti!.sferaSx = 0;
      // state.configurator.lenti!.cilindroDx = 0;
      // state.configurator.lenti!.cilindroSx = 0;
      // state.configurator.lenti!.asseDx = 0;
      // state.configurator.lenti!.asseSx = 0;
      // state.configurator.lenti!.semiDistDx = 0;
      // state.configurator.lenti!.semiDistSx = 0;
      // state.configurator.lenti!.altPupDx = 0;
      // state.configurator.lenti!.altPupSx = 0;
      // state.configurator.lenti!.addDx = 0;
      // state.configurator.lenti!.addSx = 0;
    },
    resetConfiguration(state, {
      forma,
      colore,
      coloreAste,
      sizeDescription
    }) {
      // Imposta calibro e naso
      if (sizeDescription && state.configurator.frontali !== undefined) {
        var _regularSize$, _regularSize$2;
        const regularSize = state.configurator.frontali.itemsSizes.filter(size => {
          return size.size_description == sizeDescription && size.U_THE_MODELLO == forma;
        });
        state.configurator.calibro = ((_regularSize$ = regularSize[0]) === null || _regularSize$ === void 0 ? void 0 : _regularSize$.size_eye) || '';
        state.configurator.naso = ((_regularSize$2 = regularSize[0]) === null || _regularSize$2 === void 0 ? void 0 : _regularSize$2.size_bridge) || '';
      } else {
        state.configurator.calibro = '';
        state.configurator.naso = '';
      }
      state.configurator.asianFitting = false;
      // Imposta il colore frontale (accetta anche vuoto)
      if (state.configurator.frontali != undefined) {
        if (colore === '' || colore == null) {
          state.configurator.colore = null;
        } else {
          var _state$configurator$f;
          state.configurator.colore = (_state$configurator$f = state.configurator.frontali.colors.find(col => {
            return col.U_THE_COLORE == colore;
          })) !== null && _state$configurator$f !== void 0 ? _state$configurator$f : null;
        }
      } else {
        state.configurator.colore = null;
      }
      state.configurator.finitura = "S";
      state.configurator.misuraAste = '145';
      // Imposta il colore aste (accetta anche vuoto)
      if (state.configurator.aste != undefined) {
        if (coloreAste === '' || coloreAste == null) {
          state.configurator.coloreAste = null;
        } else {
          var _state$configurator$a;
          state.configurator.coloreAste = (_state$configurator$a = state.configurator.aste.allColors.find(col => {
            return col.U_THE_COLORE == coloreAste && col.U_THE_LUNGASTA == state.configurator.misuraAste;
          })) !== null && _state$configurator$a !== void 0 ? _state$configurator$a : null;
        }
      } else {
        state.configurator.coloreAste = null;
      }
      state.configurator.coloreMetalloAste = "";
      state.configurator.finituraAste = "S";
      // Reset personalizzazioni frontali
      if (state.configurator.frontali) {
        state.configurator.frontali.name = "";
        state.configurator.frontali.nameFont = "Batang";
        state.configurator.frontali.nameColor = "";
      }
      // Reset personalizzazioni aste
      if (state.configurator.aste) {
        state.configurator.aste.extSxName = '';
        state.configurator.aste.extSxNameColor = '';
        state.configurator.aste.extSxNameFont = 'Batang';
        state.configurator.aste.intSxName = '';
        state.configurator.aste.intSxNameColor = '';
        state.configurator.aste.intSxNameFont = 'Batang';
        state.configurator.aste.extDxName = '';
        state.configurator.aste.extDxNameColor = '';
        state.configurator.aste.extDxNameFont = 'Batang';
        state.configurator.aste.intDxName = '';
        state.configurator.aste.intDxNameColor = '';
        state.configurator.aste.intDxNameFont = 'Batang';
      }
      state.configurator.note = "";
      // Imposta la forma passata
      if (forma && state.configurator.frontali != undefined) {
        let formaToSet = forma;
        if (forma.indexOf('S') >= 0 && state.configurator.glassType == 'V') {
          formaToSet = forma.replace('S', '');
        }
        const f = jslinq(state.configurator.frontali.items);
        const fd = f.firstOrDefault(front => {
          return front.U_THE_MODELLO == formaToSet;
        });
        state.configurator.frontale = fd;
      }
    },
    setLenteSx(state, l) {
      state.lenteSx = l;
    },
    setLenteDx(state, l) {
      state.lenteDx = l;
    },
    setProfileOpen: (state, po) => {
      state.profileOpen = po;
    },
    setCurrentTab: (state, ct) => {
      state.currentTab = ct;
    },
    setTemplesColor(state, tc) {
      state.coloreAste = tc;
    }
  },
  actions: {
    getUserData({
      commit
    }) {
      // @ts-ignore
      return this.$rest.getUserData().then(response => {
        commit('setUserData', response.data);
        return response.data;
      });
    }
  },
  getters: {
    marchio: state => {
      return state.marchio;
    },
    btActive: state => {
      return state.btActive;
    },
    profileOpen: state => {
      return state.profileOpen;
    },
    currentTab: state => {
      return state.currentTab;
    },
    canOrderColorSample: (state, getters) => {
      return state.configurator.colore != null && !getters.userIsGuest;
    },
    coloreAste: state => {
      return state.configurator.coloreAste;
    }
  }
});